import React, { useState, useContext, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../Context/auth';
import { getBaseUrlAnalista, ensureProtocol } from '../../config/backend';
import { fetchGruposUsuarioAtivos } from '../../api/gruposUsuario';
import { fetchMinhasEmpresas } from '../../api/empresas';
import { iniciarGestaoToken } from '../tokenManager';

import './login.css';

function Login() {

    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);

    const [sucesso, setSucesso] = useState('');
    const [mensagemErro, setMensagemErro] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [empresasDisponiveis, setEmpresasDisponiveis] = useState([]);
    const [aguardandoSelecaoEmpresa, setAguardandoSelecaoEmpresa] = useState(false);
    const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
    const { setLogado } = useContext(AuthContext);

    useEffect(() => {
        if (sucesso === 'S') iniciarGestaoToken();
    }, [sucesso]);

    const limparSessao = () => {
        localStorage.setItem("logado", "N");
        localStorage.setItem("codUsu", 0);
        localStorage.setItem("loginSati", '');
        localStorage.setItem("senhaSati", '');
        localStorage.setItem("nomUsuSat", '');
        localStorage.setItem("usrEmlSat", '');
        localStorage.setItem("perAltUsu", '');
        localStorage.setItem("equpe", '');
        localStorage.setItem("tipoSoft", '');
        localStorage.setItem("token", '');
        localStorage.setItem("empresa_id", '');
        localStorage.setItem("isSoftbridge", '');
        localStorage.setItem("empresa_nome", '');
        setLogado(false);
    };

    const handleFetchData = async (e) => {
        e.preventDefault();
        const baseUrl = getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
        setMensagemErro('');
        setCarregando(true);
        try {
            const url = baseUrl ? baseUrl + "/usuarios/userEnt" : "/usuarios/userEnt";
            const response = await axios.post(url, {
                user,
                password
            });

            const data = response.data;
            const rows = Array.isArray(data) ? data : [];
            let cod = rows.length > 0 ? rows[0].USUSEQ : 0;

            if (cod > 0) {
                const usrGru = String(rows[0].USRGRU || '').trim();

                localStorage.setItem("logado", "S");
                localStorage.setItem("codUsu", cod);
                localStorage.setItem("nomUsuSat", user);
                localStorage.setItem("usrEmlSat", rows[0].USREML);
                localStorage.setItem("perAltUsu", rows[0].PERALTUSU);
                localStorage.setItem("equpe", rows[0].EQUIPEX);
                localStorage.setItem("loginSati", user);
                localStorage.setItem("senhaSati", password);
                localStorage.setItem("tipoSoft", "ATENDENTE");

                let tokenOk = false;
                let tokenData = null;
                try {
                    const tokenUrl = baseUrl ? baseUrl + "/token" : "/token";
                    const response2 = await axios.post(tokenUrl, { user, password });
                    tokenData = response2.data;
                    const token = "Bearer " + (tokenData.token || '');
                    localStorage.setItem("token", token);
                    if (tokenData.empresa_id != null) localStorage.setItem("empresa_id", tokenData.empresa_id);
                    if (tokenData.isSoftbridge != null) localStorage.setItem("isSoftbridge", tokenData.isSoftbridge ? "S" : "N");
                    if (tokenData.empresa_nome != null) localStorage.setItem("empresa_nome", tokenData.empresa_nome);
                    if (tokenData.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(tokenData.ia_habilitada));
                    if (tokenData.per_alterar_solicitante != null) localStorage.setItem("perAltUsu", String(tokenData.per_alterar_solicitante));
                    else if (tokenData.perAltUsu != null) localStorage.setItem("perAltUsu", String(tokenData.perAltUsu));
                    tokenOk = true;
                } catch (err) {
                    if (err?.response?.status === 403 && err?.response?.data?.error === 'sem_vinculo_ativo') {
                        setMensagemErro(err.response.data.message || 'Você não possui vínculo ativo em nenhuma empresa. Entre em contato com o administrador do sistema da empresa que deseja acessar.');
                        setSucesso('N');
                        limparSessao();
                    }
                    console.error('Error fetching token:', err);
                }

                if (tokenOk) {
                    const usrGruUpper = String(tokenData?.grupo || usrGru || '').trim().toUpperCase();
                    const grupos = await fetchGruposUsuarioAtivos();
                    const grupo = grupos.find((g) => (g.codigo || '').trim().toUpperCase() === usrGruUpper);
                    const papelNorm = String(grupo?.papel ?? grupo?.Papel ?? '').trim().toLowerCase();
                    const podePorPapel = (papelNorm === 'analista' || papelNorm === 'administrador');
                    const codigosLegadoAnalista = ['ADM', 'ANA', 'SUP', 'GER'];
                    const podePorLegado = codigosLegadoAnalista.includes(usrGruUpper);
                    const backendJaValidouAnalista = (tokenData?.empresas_ativas?.length > 0) && !!tokenData?.token;
                    const podeAnalista = (grupo && podePorPapel) || podePorLegado || backendJaValidouAnalista;

                    if (!podeAnalista) {
                        limparSessao();
                        setSucesso('N');
                        setMensagemErro('Acesso restrito a analistas e administradores. Seu grupo não tem permissão para a área de analista.');
                    } else {
                        const empresas = Array.isArray(tokenData?.empresas_ativas) ? tokenData.empresas_ativas : [];
                        let listaEmpresas = empresas.length > 0 ? empresas : [];
                        if (listaEmpresas.length === 0) {
                            try {
                                listaEmpresas = await fetchMinhasEmpresas();
                            } catch (err) {
                                console.warn('Minhas empresas não disponível, usando empresa do token.', err);
                            }
                        }
                        if (listaEmpresas.length === 0) {
                            if (tokenData && tokenData.empresa_id != null) {
                                localStorage.setItem("empresa_id", tokenData.empresa_id);
                                if (tokenData.empresa_nome != null) localStorage.setItem("empresa_nome", tokenData.empresa_nome);
                                if (tokenData.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(tokenData.ia_habilitada));
                            }
                            setLogado(true);
                            setSucesso('S');
                        } else if (listaEmpresas.length === 1) {
                            localStorage.setItem("empresa_id", listaEmpresas[0].id);
                            localStorage.setItem("empresa_nome", listaEmpresas[0].nome || '');
                            if (listaEmpresas[0].ia_habilitada != null) localStorage.setItem("ia_habilitada", String(listaEmpresas[0].ia_habilitada));
                            setLogado(true);
                            setSucesso('S');
                        } else {
                            setEmpresasDisponiveis(listaEmpresas);
                            setEmpresaSelecionada(listaEmpresas[0]?.id ?? null);
                            setAguardandoSelecaoEmpresa(true);
                        }
                    }
                } else if (sucesso !== 'N' || !mensagemErro) {
                    setSucesso('N');
                    setMensagemErro('Não foi possível completar o login. Tente novamente.');
                }
            } else {
                limparSessao();
                setSucesso('N');
                setMensagemErro('');
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response?.status === 404 || error.response?.status === 400) {
                limparSessao();
                setSucesso('N');
            } else if (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error')) {
                setMensagemErro('Não foi possível conectar ao servidor. Verifique a URL do backend (REACT_APP_BACKEND_ANALISTA) e se o servidor está em execução.');
                setSucesso('N');
            }
        } finally {
            setCarregando(false);
        }
    };

    const confirmarEmpresa = async () => {
        const emp = empresasDisponiveis.find((e) => e.id === empresaSelecionada);
        if (!emp) return;
        setCarregando(true);
        setMensagemErro('');
        const baseUrl = getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
        const token = localStorage.getItem('token');
        try {
            if (baseUrl && token) {
                const res = await axios.post(baseUrl + '/token/contexto', { empresa_id: emp.id }, { headers: { Authorization: token } });
                if (res.data?.token) {
                    localStorage.setItem('token', res.data.token.startsWith('Bearer ') ? res.data.token : 'Bearer ' + res.data.token);
                }
                if (res.data?.empresa_id != null) localStorage.setItem('empresa_id', res.data.empresa_id);
                if (res.data?.empresa_nome != null) localStorage.setItem('empresa_nome', res.data.empresa_nome);
                if (res.data?.isSoftbridge != null) localStorage.setItem('isSoftbridge', res.data.isSoftbridge ? 'S' : 'N');
                if (res.data?.ia_habilitada != null) localStorage.setItem('ia_habilitada', String(res.data.ia_habilitada));
                if (res.data?.per_alterar_solicitante != null) localStorage.setItem('perAltUsu', String(res.data.per_alterar_solicitante));
                else if (res.data?.perAltUsu != null) localStorage.setItem('perAltUsu', String(res.data.perAltUsu));
            } else {
                localStorage.setItem("empresa_id", emp.id);
                localStorage.setItem("empresa_nome", emp.nome || '');
                if (emp.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(emp.ia_habilitada));
            }
            setAguardandoSelecaoEmpresa(false);
            setLogado(true);
            setSucesso('S');
        } catch (err) {
            setMensagemErro(err?.response?.data?.message || 'Não foi possível alterar o contexto da empresa.');
        } finally {
            setCarregando(false);
        }
    };

    const Brand = ({ tagline }) => (
        <section className="login-brand">
            <span className="login-orb login-orb--1" aria-hidden="true" />
            <span className="login-orb login-orb--2" aria-hidden="true" />
            <div className="login-brand-inner">
                <Link to="/">
                    <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" className="login-logo" />
                </Link>
                <p className="login-tagline">{tagline}</p>
                <ul className="login-features">
                    <li><i className="fas fa-headset" /> Atenda e acompanhe chamados</li>
                    <li><i className="fas fa-chart-line" /> Dashboards, sprints e relatórios</li>
                    <li><i className="fas fa-shield-halved" /> Acesso seguro por empresa</li>
                </ul>
            </div>
        </section>
    );

    if (aguardandoSelecaoEmpresa && empresasDisponiveis.length > 1 && sucesso !== 'S') {
        return (
            <div className="login-page">
                <Brand tagline="Selecione a empresa para continuar" />
                <div className="login-form-wrap">
                    <div className="login-form-card">
                        <h2><i className="fas fa-building" /> Selecionar empresa</h2>
                        <p className="subtitle">Você tem acesso a mais de uma empresa. Escolha com qual deseja trabalhar.</p>
                        <div className="login-field">
                            <label htmlFor="selecao-empresa">Empresa</label>
                            <select
                                id="selecao-empresa"
                                className="login-select-empresa"
                                value={empresaSelecionada ?? ''}
                                onChange={(e) => setEmpresaSelecionada(e.target.value ? Number(e.target.value) : null)}
                            >
                                {empresasDisponiveis.map((emp) => (
                                    <option key={emp.id} value={emp.id}>{emp.nome || `Empresa ${emp.id}`}</option>
                                ))}
                            </select>
                        </div>
                        {mensagemErro && (
                            <div className="login-alert login-alert--error" role="alert"><i className="fas fa-circle-exclamation" /> <strong>{mensagemErro}</strong></div>
                        )}
                        <button type="button" className="login-submit" onClick={confirmarEmpresa} disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Carregando...</> : <>Continuar <i className="fas fa-arrow-right" /></>}
                        </button>
                        <footer className="login-footer">
                            <div className="login-footer-line">
                                <Link to="/" onClick={limparSessao}>Voltar à escolha de acesso</Link>
                            </div>
                            <div className="login-footer-line">
                                &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <Brand tagline="Central de atendimento e chamados. Entre com suas credenciais de atendente ou analista." />
            <div className="login-form-wrap">
                <div className="login-form-card">
                    <h2><i className="fas fa-user-shield" /> Área do Analista</h2>
                    <p className="subtitle">Entre com seu usuário e senha</p>
                    <form onSubmit={handleFetchData}>
                        <div className="login-field">
                            <label htmlFor="floatingInput">Usuário</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-user login-input-icon" />
                                <input
                                    id="floatingInput"
                                    type="text"
                                    value={user}
                                    onChange={(e) => setUser(e.target.value)}
                                    placeholder="Seu usuário"
                                    autoComplete="username"
                                    required
                                    disabled={carregando}
                                />
                            </div>
                        </div>
                        <div className="login-field">
                            <label htmlFor="floatingPassword">Senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="floatingPassword"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Sua senha"
                                    autoComplete="current-password"
                                    required
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-senha"
                                    onClick={() => setMostrarSenha((v) => !v)}
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    tabIndex={-1}
                                >
                                    <i className={mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'} />
                                </button>
                            </div>
                        </div>
                        <button type="submit" className="login-submit" disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Entrando...</> : <>Entrar <i className="fas fa-arrow-right" /></>}
                        </button>
                    </form>
                    {sucesso === 'N' ? (
                        <div className="login-alert login-alert--error" role="alert">
                            <i className="fas fa-circle-exclamation" /> <strong>{mensagemErro || 'Usuário ou senha inválidos.'}</strong>
                        </div>
                    ) : null}
                    {sucesso === 'S' ? (password.trim() !== "alterar123" ? <Redirect to="/home" /> : <Redirect to="/alterarSenha" />) : null}

                    <footer className="login-footer">
                        <div className="login-footer-line">
                            <Link to="/">Voltar à escolha de acesso</Link>
                        </div>
                        <div className="login-footer-line">
                            &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default Login;
